import { Tabs } from "antd";
import React from "react";
import useTabChange from "../../hooks/useTabChange";

const normalizeTabKey = (key) => {
  if (typeof key !== "string") {
    return key;
  }

  if (key.startsWith("#.$")) {
    return "#" + key.slice(3);
  }

  if (key.startsWith(".$")) {
    return key.slice(2);
  }

  return key;
};

/**
 * Ant Design tabs with active key as a hash in the URL.
 *
 * @param defaultActiveKey
 * @param size
 * @param props
 * @param onChange
 * @returns {Element}
 * @constructor
 */
const CustomTabs = ({ defaultActiveKey = "#overview", onChange = null, size= "small", ...props }) => {
  const tabKeys = React.useMemo(
    () =>
      React.Children.map(props.children, (child) => normalizeTabKey(child?.key)) || []
        .filter(Boolean),
    [props.children]
  );
  const [activeTab, setActiveTab] = useTabChange(props?.props, defaultActiveKey, tabKeys);

  return (
    <Tabs size={size} activeKey={activeTab} onChange={(e) => {
      const normalizedTabKey = normalizeTabKey(e);

      setActiveTab(normalizedTabKey);
      if (onChange) onChange(normalizedTabKey);
    }} {...props}>
      {props.children}
    </Tabs>
  );
};

export default CustomTabs;
